import React from "react";
import PropTypes from "prop-types";
import { FormikField } from "@qgiv/core-donor";
import * as formViews from "./constants/formViews";

const EmailAndPassword = ({ formView }) => {
    // All the visual details associated with the locked email input
    // Conditional logic will need to be applied to these details once
    // legitimate use cases for the account form where we do not want the email
    // input to be locked have been developed
    const lockedInputDetails = {
        descIcon: {
            glyph: "lock-alt-solid",
            type: "FontAwesome",
        },
        readOnly: true,
        innerBackground: true,
        autoComplete: "off",
    };
    let passwordLabel = "Password";

    if (
        formView === formViews.ACTIVATE_ACCOUNT ||
        formView === formViews.RESET_PASSWORD
    ) {
        // Reset your password or activate your account
        passwordLabel = "Create Password";
    }

    return (
        <div className="grid">
            <div className="col col--12">
                <FormikField
                    type="email"
                    name="Email"
                    id="Email"
                    label="Email"
                    autoComplete="email"
                    {...lockedInputDetails}
                />
            </div>
            <div className="col col--12">
                <FormikField
                    type="password"
                    name="Password"
                    id="Password"
                    label={passwordLabel}
                />
            </div>
        </div>
    );
};

EmailAndPassword.propTypes = {
    formView: PropTypes.string.isRequired,
};

export default EmailAndPassword;
